import React, { FC, useCallback, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import TermsOfService0903Modal from '@/components/NolPromotion/NolPromotionAgreementModal/TermsOfService0903/TermsOfServiceModal';

/**
 * 놀카드 개인정보 제공 필수안 제거
 * @see {@link https://yanolja.atlassian.net/wiki/spaces/PLCC/pages/420779686/2024-09-dd+PLCC#%EA%B2%80%ED%86%A0%EC%95%88}
 * @constructor
 */
const NolPromotionAgreement0903Modal: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  const onRequestClose = useCallback(() => {
    store.isAgreement0903Open = false;
  }, []);

  const onSubmit = useCallback(() => {
    store.waitForAgreement?.complete(true);
  }, []);

  return (
    <TermsOfService0903Modal
      title={'NOL 카드 약관 동의'}
      isOpen={store.isAgreement0903Open}
      onRequestClose={onRequestClose}
      onSubmit={onSubmit}
    />
  );
};

export default observer(NolPromotionAgreement0903Modal);
